<template>
	<div  style="width: 100%;height: calc(100vh - 60px);">
		<PageHeader @back="goback" :content="'电访设置'" />
		<div class="settings-content">
			<div class="settings-section">
				<div class="section-header">
					<div class="section-title">
						<i class="el-icon-monitor"></i>
						<span>电访设置</span>
					</div>
				</div>
				
				<div class="settings-list">
					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">
								禁止修改拨打电话:
							</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isBanModifyPhone" @change="onSubmit"></el-switch>
						</div>
					</div>
					
					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">隐藏电话:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isHidePhone" @change="onSubmit"></el-switch>
						</div>
					</div>
					
					
					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">访问端可修改样本:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.accessprotModifySample" @change="onSubmit"></el-switch>
						</div>
					</div>

					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">是否启用拨打控制:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isEnableCallControl" @change="onSubmit"></el-switch>
							<span>
								&nbsp;&nbsp;最多拨打次数&nbsp;&nbsp;
								<el-input size="medium" v-model="form.callControlSum" style="width: 100px;" @blur="onSubmit"></el-input>
								&nbsp;&nbsp;次
							</span>
						</div>
					</div>

					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">约访分钟数提示:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isEnableAppointmentMinuteHint"></el-switch>
							<span>
								&nbsp;&nbsp;到&nbsp;&nbsp;
								<el-input size="medium" v-model="form.appointmentMinuteSum" style="width: 100px;" @blur="onSubmit"></el-input>
								&nbsp;&nbsp;分钟提示
							</span>
						</div>
					</div>

					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">放回样本可读取间隔时间:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isPutSampleReadIntervalTime"></el-switch>
							<span>
								&nbsp;&nbsp;分钟提示&nbsp;&nbsp;
								<el-input size="medium" v-model="form.putSampleReadIntervalTimeSum" style="width: 100px;" @blur="onSubmit"></el-input>
								&nbsp;&nbsp;分钟
							</span>
						</div>
					</div>

					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">坐席绑定方式:</div>
						</div>
						<div class="setting-control">
							<el-select size="medium" v-model="form.dialsearchtype" placeholder="请选择" @change="onSubmit">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<!-- <el-button size="medium" type="primary" @click="onSubmit">确定</el-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		PageHeader
	},
	data() {
		return {
			options: [
				{
					value:1,
					label: '按绑定访员工号获取坐席'
				},
				{
					value: 2,
					label: '按电脑IP获取坐席'
				},
				{
					value: 3,
					label: '坐席池内获取为使用坐席'
				}
			],
			value: '',
			id: '',
			form: {},
			isMessageShowing: false,
			messageTimer: null
		};
	},
	computed: {
		selectIndex() {
			let state
			if (this.$route.query.source == 'df') {
				state = 3
			}else if (this.$route.query.source == 'mf') {
				state = 4
			}
			return state
		}
	},
	created() {
		this.id = this.$route.query.id;
		this.loadData();
	},
	methods: {
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryControllerProperty}?id=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						let systemSetup = {
							id: res.resultBody.id, //问卷id
							content: res.resultBody.content, //问卷描述
							wjTitle: res.resultBody.wjTitle, //问卷标题
							accessprotModifySample: res.resultBody.accessprotModifySample == 0 ? false : true, //访问端可修改样本(0不可以，1可以修改)
							isBanModifyPhone: res.resultBody.isBanModifyPhone == 0 ? false : true, //是否禁止修改拨打电话(0不禁止，1禁止)
							isHidePhone: res.resultBody.isHidePhone == 0 ? false : true, //是否隐藏电话(0不隐藏，1隐藏)
							isEnableAppointmentMinuteHint: res.resultBody.isEnableAppointmentMinuteHint == 0 ? false : true, //是否启用约访分钟数提示(0不开启，1开启)
							appointmentMinuteSum: res.resultBody.appointmentMinuteSum, //提示分数数
							isEnableCallControl: res.resultBody.isEnableCallControl == 0 ? false : true, //是否启用拨打控制(0不开启，1开启)
							callControlSum: res.resultBody.callControlSum, //拨打控制最多拨打次数
							isPutSampleReadIntervalTime: res.resultBody.isPutSampleReadIntervalTime == 0 ? false : true, //是否开启放回样本可读取间隔时间(0不开启，1开启)
							putSampleReadIntervalTimeSum: res.resultBody.putSampleReadIntervalTimeSum ,//放回样本可读取间隔时间数
							dialsearchtype:res.resultBody.dialsearchtype,//坐席绑定方式
							isEntry: res.resultBody.isEntry // 是否显示录入功能
						};
						that.form = systemSetup;
						console.log(systemSetup);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		onSubmit() {
			this.switchIsOpenEntry()
			let data = {
				id: this.form.id, //问卷id
				// content: this.form.content, //问卷描述
				// wjTitle: this.form.wjTitle, //问卷标题
				accessprotModifySample: this.form.accessprotModifySample == false ? 0 : 1, //访问端可修改样本(0不可以，1可以修改)
				isBanModifyPhone: this.form.isBanModifyPhone == false ? 0 : 1, //是否禁止修改拨打电话(0不禁止，1禁止)
				isHidePhone: this.form.isHidePhone == false ? 0 : 1, //是否隐藏电话(0不隐藏，1隐藏)
				isEnableAppointmentMinuteHint: this.form.isEnableAppointmentMinuteHint == false ? 0 : 1, //是否启用约访分钟数提示(0不开启，1开启)
				appointmentMinuteSum: this.form.appointmentMinuteSum, //提示分数数
				isEnableCallControl: this.form.isEnableCallControl == false ? 0 : 1, //是否启用拨打控制(0不开启，1开启)
				callControlSum: this.form.callControlSum, //拨打控制最多拨打次数
				isPutSampleReadIntervalTime: this.form.isPutSampleReadIntervalTime == false ? 0 : 1, //是否开启放回样本可读取间隔时间(0不开启，1开启)
				putSampleReadIntervalTimeSum: this.form.putSampleReadIntervalTimeSum ,//放回样本可读取间隔时间数
				dialsearchtype: this.form.dialsearchtype//坐席绑定方式
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyControllerProperty}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						// that.$message.success(res.message);
						// 如果已经有提示在显示，不再重复弹出
						if (that.isMessageShowing) {
							return;
						}
						
						that.isMessageShowing = true;
						that.$message.success(res.message);
						
						// 设置2秒后重置标志位（Element UI message默认显示3秒）
						clearTimeout(that.messageTimer);
						that.messageTimer = setTimeout(() => {
							that.isMessageShowing = false;
						}, 2000);
					} else {
						// that.$message.error(res.message);
						if (!that.isMessageShowing) {
							that.$message.error(res.message);
						}
					}
				}
			};
			this.$util.request(params);
		},
		// 是否开启录入功能
		switchIsOpenEntry() {
			// 1开 0 关
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setModifyIsEntry}`,
				method: "POST",
				data: {
					id: this.id,
					isEntry: this.form.isEntry
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				},
			};
			this.$util.request(params);
		},
		goback() {
			this.$router.go(-1)
		}
	},
	beforeDestroy() {
		clearTimeout(this.messageTimer);
	}
};
</script>

<style lang="scss" scoped>
.settings-content {
	width: 1000px;
	margin: 0 auto;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	overflow: hidden;
}
.settings-section {
	padding: 0;
	border-bottom: 1px solid #ebeef5;
}

.settings-section:last-child {
	border-bottom: none;
}

.section-header {
	padding: 20px 24px;
	background: #fafbfc;
	border-bottom: 1px solid #ebeef5;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	display: flex;
	align-items: center;
	gap: 8px;
}
.settings-list {
	padding: 0;
}

.setting-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 24px;
	border-bottom: 1px solid #f0f2f5;
	transition: background-color 0.2s;
}

.setting-item:hover {
	background-color: #fafbfc;
}

.setting-item:last-child {
	border-bottom: none;
}

.setting-info {
	flex: 1;
	min-width: 0;
}

.setting-title {
	font-size: 14px;
	font-weight: 500;
	color: #303133;
	margin-bottom: 4px;
}

.setting-desc {
	font-size: 13px;
	color: #909399;
	line-height: 1.4;
}

.setting-control {
	margin-left: 20px;
	min-width: 120px;
	text-align: right;
	font-size: 14px;
}
</style>
